import React from 'react';
import PropTypes from 'prop-types';

import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import formatPrescriberName from 'utils/formatPrescriberName';

const PrescribersSearchDialogListItem = ({
  first_name,
  last_name,
  name_prefix,
  name_suffix,
  credential,
  npi,
  addresses,
  taxonomies,
  onClick,
  selected,
}) => (
  <TableRow
    hover
    selected={selected}
    {...onClick ? { onClick } : {}}
  >
    <TableCell>
      {formatPrescriberName({
        'Name Prefix': name_prefix,
        'First Name': first_name,
        'Last Name': last_name,
        'Name Suffix': name_suffix && name_suffix !== '--' ? name_suffix : '',
        Credential: credential,
      })}
    </TableCell>
    <TableCell>
      {npi}
    </TableCell>
    <TableCell>
      {addresses[0].address}
    </TableCell>
    <TableCell>
      {addresses[0].city}
    </TableCell>
    <TableCell>
      {addresses[0].state}
    </TableCell>
    <TableCell>
      {addresses[0].phone}
    </TableCell>
    <TableCell>
      {taxonomies[0].desc}
    </TableCell>
  </TableRow>
);

PrescribersSearchDialogListItem.propTypes = {
  first_name: PropTypes.string.isRequired,
  last_name: PropTypes.string.isRequired,
  name_prefix: PropTypes.string,
  name_suffix: PropTypes.string,
  credential: PropTypes.string,
  npi: PropTypes.number.isRequired,
  addresses: PropTypes.arrayOf(PropTypes.shape({
    address: PropTypes.string,
  })).isRequired,
  taxonomies: PropTypes.arrayOf(PropTypes.shape({
    desc: PropTypes.string,
  })).isRequired,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
};

PrescribersSearchDialogListItem.defaultProps = {
  name_prefix: null,
  name_suffix: null,
  credential: null,
  onClick: null,
  selected: false,
};

export default PrescribersSearchDialogListItem;



// WEBPACK FOOTER //
// ./src/components/settings/PrescribersSearchDialog/PrescribersSearchDialogListItem.js